module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/3/4-95759a6ee17810c7d5cafab12acfba06.jpg";